/**
 * 使用者關掉過哪一則公告。
 *
 * 存 id 而不是布林：存布林的話，關掉某一則之後，之後每一則新公告都會被
 * 一起擋住。
 */
const DISMISSED_KEY = "fight-health-notice-dismissed-v1";

export function dismissedNoticeId(): string | null {
  try {
    return localStorage.getItem(DISMISSED_KEY);
  } catch {
    return null;
  }
}

export function dismissNotice(id: string): void {
  localStorage.setItem(DISMISSED_KEY, id);
}
